import styled, { keyframes } from 'styled-components';

export const RelatedItemsContainer = styled.div`
    gap: 1rem;
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (max-width: 1300px) {
      justify-content: center;
      align-items: center;

      h3 {
        width: 56%;
      }
    }
`;

export const Item = styled.div`
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 7rem;

    border-radius: 1rem;
    overflow: hidden;

    @media (max-width: 1300px) {
      width: 56%;
    }

    &:hover {
        .grow {
            flex-grow: 1;
            max-height: 100% !important;
            transition: max-height 0.5s ease;
        }
        .content {
            &::before {
                content: '';
                position: absolute;
                z-index: 1;
                inset: 0;
                opacity: 0.85;
                background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 1) 0%,
                    rgba(0, 0, 0, 0) 150%
                );
                transition: opacity 0.5s ease;
            }

            .descriptor {
                opacity: 1;
                max-height: 100%;

                transition: all 0.5s ease;
            }
        }
    }

    .content {
        &::before {
            content: '';
            position: absolute;
            z-index: 1;
            inset: 0;
            opacity: 0.25;
            transition: opacity 0.25s ease;
            background: linear-gradient(
                0deg,
                rgba(0, 0, 0, 1) 0%,
                rgba(0, 0, 0, 0) 150%
            );
        }

        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0.75rem;
        overflow: hidden;
        z-index: 2;
        color: #fff;

        .title {
            z-index: 3;
            width: 100%;
            gap: 0.25rem;
            display: inline-flex;
            align-items: center;
            margin-top: auto;
        }
        .grow {
            flex-grow: 1;
            max-height: 0%;
            transition: max-height 0.5s ease;
        }
        .descriptor {
            display: flex;
            flex-direction: column;
            z-index: 3;
            opacity: 0;
            max-height: 0;
            color: rgba(255, 255, 255, 0.8);
            font-family: 'Hero New';
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 0.875rem;
            transition: all 0.5s ease;
            gap: 0.1rem;

            p {
                display: -webkit-box;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                line-clamp: 3;
                overflow: hidden;
            }
        }
    }

    @media (max-width: 800px) {
        .grow {
            flex-grow: 1;
            max-height: 100% !important;
            transition: max-height 0.5s ease;
        }

        .content {
            &::before {
                content: '';
                position: absolute;
                z-index: 1;
                inset: 0;
                opacity: 0.85;
                background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 1) 0%,
                    rgba(0, 0, 0, 0) 150%
                );
                transition: opacity 0.25s ease;
            }
            .descriptor {
                opacity: 1;
                max-height: 100%;

                transition: all 0.25s ease;
            }
        }
    }
    img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
    }
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    color: white;
    font-size: 1.5em;
`;

const pulse = keyframes`
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f5f5f5;
  }
  100% {
    background-color: #e0e0e0;
  }
`;

export const ItemSkeleton = styled.div`
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 7rem;
    border-radius: 1rem;
    overflow: hidden;
    background-color: #e0e0e0;
    animation: ${pulse} 1.5s infinite ease-in-out;
`;
